import React, { useMemo, useEffect, useLayoutEffect, useContext, useRef, useReducer, useCallback, memo, createElement } from 'react';
import { unstable_batchedUpdates } from 'react-dom';
import invariant from 'invariant';
import { isArray, isFunction, isUndefined, isPlainObject as isPlainObject$1, isString, isObject, isPromise, createHocRef, pluginSpecialHookHelper, isNode } from '@jupiter-app/utils';
import { createSelectorCreator } from 'reselect';
import hoistNonReactStatic from 'hoist-non-react-statics';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function () {};

      return {
        s: F,
        n: function () {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function (e) {
          throw e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function () {
      it = it.call(o);
    },
    n: function () {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function (e) {
      didErr = true;
      err = e;
    },
    f: function () {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var $$observable = /* #__PURE__ */function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT".concat( /* #__PURE__ */randomString()),
  REPLACE: "@@redux/REPLACE".concat( /* #__PURE__ */randomString()),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION".concat(randomString());
  }
};

/**
 * @param obj - The object to inspect.
 * @returns True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (_typeof(obj) !== 'object' || obj === null) {
    return false;
  }

  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

function createStore(reducer, preloadedState, enhancer) {
  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /*
   * This makes a shallow copy of currentListeners so we can use
  nextListeners as a temporary list while dispatching.
   This prevents any bugs around consumers calling
  subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /*
   * Reads the state tree managed by the store.
   *
   * @returns The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /*
   * Adds a change listener. It will be called any time an action is dispatched,
  and some part of the state tree may potentially have changed. You may then
  call `getState()` to read the current state tree inside the callback.
   You may call `dispatch()` from a change listener, with the following
  caveats:
   1. The subscriptions are snapshotted just before every `dispatch()` call.
  If you subscribe or unsubscribe while the listeners are being invoked, this
  will not have any effect on the `dispatch()` that is currently in progress.
  However, the next `dispatch()` call, whether nested or not, will use a more
  recent snapshot of the subscription list.
   2. The listener should not expect to see all state changes, as the state
  might have been updated multiple times during a nested `dispatch()` before
  the listener is called. It is, however, guaranteed that all subscribers
  registered before the `dispatch()` started will be called with the latest
  state by the time it exits.
   *
   * @param listener - A callback to be invoked on every dispatch.
   * @returns A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected the listener to be a function.');
    }

    if (isDispatching) {
      throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }

  var store;
  /*
   * Dispatches an action. It is the only way to trigger a state change.
   The `reducer` function, used to create the store, will be called with the
  current state tree and the given `action`. Its return value will
  be considered the **next** state of the tree, and the change listeners
  will be notified.
   The base implementation only supports plain object actions. If you want to
  dispatch a Promise, an Observable, a thunk, or something else, you need to
  wrap your store creating function into the corresponding middleware. For
  example, see the documentation for the `redux-thunk` package. Even the
  middleware will eventually dispatch plain object actions using this method.
   *
   * @param action - A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   * @returns For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */

  function dispatch(action) {
    var _store, _store$_context;

    if (!isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    } // NOTICE: if replaceReducer, not trigger the store.subscribe callback


    if (action && action.type === ActionTypes.REPLACE) {
      return;
    }

    var _batch = (_store = store) === null || _store === void 0 ? void 0 : (_store$_context = _store._context) === null || _store$_context === void 0 ? void 0 : _store$_context._batch;

    if (_batch !== null && _batch !== void 0 && _batch.isInBatch) {
      _batch.tagHasUpdates();

      return action;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /*
   * Replaces the reducer currently used by the store to calculate the state.
   You might need this if your app implements code splitting and you want to
  load some of the reducers dynamically. You might also need this if you
  implement a hot reloading mechanism for Redux.
   *
   * @param nextReducer - The reducer for the store to use instead.
   * @returns The same store instance with a new reducer in place.
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    } // TODO: do this more elegantly


    currentReducer = nextReducer; // ((currentReducer as unknown) as Reducer<
    //   NewState,
    //   NewActions
    // >) = nextReducer;
    // This action has a similar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    }); // change the type of the store by casting it to the new store

    return store;
  }
  /*
   * Interoperability point for observable/reactive libraries.
   *
   * @returns A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var outerSubscribe = subscribe;
    return _defineProperty({
      /*
       * The minimal observable subscription method.
       *
       * @param observer - Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (_typeof(observer) !== 'object' || observer === null) {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          var observerAsObserver = observer;

          if (observerAsObserver.next) {
            observerAsObserver.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, $$observable, function () {
      return this;
    });
  }

  function notifyListeners() {
    currentListeners = nextListeners;

    var _iterator = _createForOfIteratorHelper(currentListeners),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var listener = _step.value;
        listener();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  store = _defineProperty({
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer,
    notifyListeners: notifyListeners
  }, $$observable, observable);
  return store;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param message The warning message.
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUndefinedStateErrorMessage(key, action) {
  var actionType = action === null || action === void 0 ? void 0 : action.type;
  var actionDescription = actionType && "action \"".concat(String(actionType), "\"") || 'an action';
  return "Given ".concat(actionDescription, ", reducer \"").concat(key, "\" returned undefined. ") + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.";
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    var match = /\s([a-z|A-Z]+)/.exec(Object.prototype.toString.call(inputState));
    var matchType = match ? match[1] : '';
    return "The ".concat(argumentName, " has unexpected type of \"").concat(matchType, "\". Expected argument to be an object with the following ") + "keys: \"".concat(reducerKeys.join('", "'), "\"");
  } // const unexpectedKeys = Object.keys(inputState).filter(
  //   key => !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key],
  // );
  // unexpectedKeys.forEach(key => {
  //   unexpectedKeyCache[key] = true;
  // });


  if (action && action.type === ActionTypes.REPLACE) {
    return undefined;
  }

  return undefined; // if (unexpectedKeys.length > 0) {
  //   return (
  //     `Unexpected ${unexpectedKeys.length > 1 ? 'keys' : 'key'} ` +
  //     `"${unexpectedKeys.join('", "')}" found in ${argumentName}. ` +
  //     `Expected to find one of the known reducer keys instead: ` +
  //     `"${reducerKeys.join('", "')}". Unexpected keys will be ignored.`
  //   );
  // }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error("Reducer \"".concat(key, "\" returned undefined during initialization. ") + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error("Reducer \"".concat(key, "\" returned undefined when probed with a random type. ") + "Don't try to handle ".concat(ActionTypes.INIT, " or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}

function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (process.env.NODE_ENV !== 'production') {
      if (typeof reducers[key] === 'undefined') {
        process.env.NODE_ENV !== "production" ? warning("No reducer provided for key \"".concat(key, "\"")) : void 0;
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.
  // let unexpectedKeyCache: { [key: string]: true };
  // if (process.env.NODE_ENV !== 'production') {
  //   unexpectedKeyCache = {};
  // }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (process.env.NODE_ENV !== 'production') {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);

      if (warningMessage) {
        process.env.NODE_ENV !== "production" ? warning(warningMessage) : void 0;
      }
    }

    var waitToDeletedKeys = [];
    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      } else if (nextStateForKey === '__reduck_clear_state__') {
        hasChanged = true;
        nextStateForKey = undefined;
        waitToDeletedKeys.push(_key);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    var newState = hasChanged ? _objectSpread2(_objectSpread2({}, state), nextState) : state;
    waitToDeletedKeys.forEach(function (key) {
      delete newState[key];
    });
    return newState;
  };
}

function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    // infer the argument type so it is usable in inference down the line
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var store = createStore.apply(void 0, [reducer].concat(args));

      var _dispatch = function dispatch() {
        throw new Error('Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
            args[_key3 - 1] = arguments[_key3];
          }

          return _dispatch.apply(void 0, [action].concat(args));
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, _toConsumableArray(chain))(store.dispatch);
      return Object.assign(store, {
        dispatch: _dispatch
      });
    };
  };
}

// functions
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  process.env.NODE_ENV !== "production" ? warning('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.') : void 0;
}

// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = getBatch(); // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?

  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) {
          return;
        }

        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(store, parentSub) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  _createClass(Subscription, [{
    key: "addNestedSub",
    value: function addNestedSub(listener) {
      this.trySubscribe();
      return this.listeners.subscribe(listener);
    }
  }, {
    key: "notifyNestedSubs",
    value: function notifyNestedSubs() {
      this.listeners.notify();
    }
  }, {
    key: "handleChangeWrapper",
    value: function handleChangeWrapper() {
      if (this.onStateChange) {
        this.onStateChange();
      }
    }
  }, {
    key: "isSubscribed",
    value: function isSubscribed() {
      return Boolean(this.unsubscribe);
    }
  }, {
    key: "trySubscribe",
    value: function trySubscribe() {
      if (!this.unsubscribe) {
        this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
        this.listeners = createListenerCollection();
      }
    }
  }, {
    key: "tryUnsubscribe",
    value: function tryUnsubscribe() {
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
        this.listeners.clear();
        this.listeners = nullListeners;
      }
    }
  }]);

  return Subscription;
}();

var ReactReduxContext = React.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ReactReduxContext.displayName = 'ReactRedux';
}

Provider.defaultProps = {
  config: {},
  context: undefined
};

function Provider(_ref) {
  var store = _ref.store,
      config = _ref.config,
      children = _ref.children,
      context = _ref.context;
  var contextValue = useMemo(function () {
    var subscription = new Subscription(store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      config: config,
      subscription: subscription
    };
  }, [store]);
  var previousState = useMemo(function () {
    return store.getState();
  }, [store]);
  useEffect(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return React.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (_typeof(objA) !== 'object' || objA === null || _typeof(objB) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

setBatch(unstable_batchedUpdates);

function genMapState(_models, map) {
  var models = _models.filter(Boolean);

  var prevStateList = null;
  var prevProps = null;
  var prevUserState = null;
  return function (state, ownProps) {
    var changed = !shallowEqual(ownProps, prevProps);
    prevProps = ownProps;
    var modelsState = models.map(function (model) {
      var name = model.name,
          computed = model.computed;
      var modelState = state[name];
      var computedState = {};
      computed && Object.keys(computed).reduce(function (_computedState, computedKey) {
        _computedState[computedKey] = modelState[computedKey];
        return computedState;
      }, computedState);
      return _objectSpread2(_objectSpread2({}, modelState), computedState);
    });

    if (!changed && prevStateList && prevStateList.every(function (prev, i) {
      return shallowEqual(prev, modelsState[i]);
    })) {
      return prevUserState;
    } else {
      prevStateList = modelsState;
    }

    var curState = modelsState.reduce(function (result, modelState) {
      return Object.assign(result, modelState);
    }, {});

    if (isFunction(map)) {
      if (ownProps) {
        prevUserState = map.apply(void 0, _toConsumableArray(modelsState).concat([ownProps, state]));
      } else {
        prevUserState = map.apply(void 0, _toConsumableArray(modelsState).concat([state]));
      }

      return prevUserState;
    }

    prevUserState = curState;
    return curState;
  };
}
function genMapActions(models, map) {
  var modelsName = models.filter(Boolean).map(function (model) {
    return model.name;
  });
  return function (dispatch, ownProps) {
    var modelsAction = modelsName.map(function (modelName) {
      return dispatch[modelName];
    });

    if (isFunction(map)) {
      return map.apply(void 0, _toConsumableArray(modelsAction).concat([ownProps]));
    }

    return modelsAction.reduce(function (result, modelAction) {
      return Object.assign(result, modelAction);
    }, {});
  };
}
function parseUseModels(arg) {
  var isLocal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    var args = isArray(arg) ? arg : [arg]; // when useModel(state => xx, actions => xxx);
    // args[0] selectorState
    // args[1] selectorActions

    if (isFunction(args[0]) || args[0] == null) {
      return [undefined, args[0], isFunction(args[1]) ? args[1] : function (actions) {
        return actions;
      }];
    }

    var length = args.length;
    var lastMap = args[length - 1];
    var sencondLastMap = args[length - 2];
    var models;
    var mapState;
    var mapActions;
    var isFunctionLastMap = isFunction(lastMap);
    var isFunctionSencondLastMap = isFunction(sencondLastMap);
    var isUndefinedSencondLastMap = isUndefined(sencondLastMap);

    if (length === 1) {
      // when single model, useModel(xxModel) | useModel([xxModel])
      models = args;
      mapState = undefined;
      mapActions = undefined;
    } else if (isFunctionSencondLastMap || isUndefinedSencondLastMap && isFunctionLastMap) {
      // when multiple models and selectorState and selectorActions
      // useModel([xxModel, selectorState, selectorActions])
      // useModel([xxModel, undefined, selectorActions])
      models = args.slice(0, -2);
      mapState = sencondLastMap;
      mapActions = lastMap;
    } else if (isFunctionLastMap) {
      // when multiple models and selectorState
      // useModel([xxModel, selectorState])
      models = args.slice(0, -1);
      mapState = lastMap;
      mapActions = undefined;
    } else {
      models = args;
      mapState = undefined;
      mapActions = undefined;
    }

    if (isLocal && models.length === 1 && !models[0].name) {
      models[0].name = 'localModel';
    }

    var selectorState = genMapState(models, mapState);
    var selectorActions = genMapActions(models, mapActions);
    return [models, selectorState, selectorActions];
  };
}

var hasSymbol = typeof Symbol !== 'undefined' && _typeof(Symbol('x')) === 'symbol';
var DRAFT_STATE = hasSymbol ? Symbol["for"]('immer-state') : '__$immer_state';
/**
 * 判断是否是 draft https://github.com/immerjs/immer/blob/6555173838f575d48a3fcb825c5a7d1953573a11/src/utils/common.ts#L21
 */

var isDraft = function isDraft(value) {
  return Boolean(value) && Boolean(value[DRAFT_STATE]);
};

var equalCheck = function equalCheck(a, b) {
  return a === b;
};

var areArgumentsShallowlyEqual = function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


  var length = prev.length;

  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}; // copy from reselect


var defaultMemoize = function defaultMemoize(func, equalCheckFn) {
  var lastArgs = null;
  var lastResult = null; // we reference arguments instead of spreading them for performance reasons

  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // 在 immer 中触发 computed 重新计算，认为缓存失效
    if (args.some(function (arg) {
      return isDraft(arg);
    })) {
      return lastResult;
    }

    if (!areArgumentsShallowlyEqual(equalCheckFn, lastArgs, args)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(void 0, args);
      lastArgs = args;
    }

    return lastResult;
  };
};
/**
 * 单函数缓存算法
 */


var memorize = function memorize(fn) {
  return defaultMemoize(fn, equalCheck);
};
var createSelector = createSelectorCreator(memorize);
/**
 * 带有 selectors 的缓存
 */

var memorizeSelector = function memorizeSelector(selectors) {
  if (!(selectors !== null && selectors !== void 0 && selectors.length)) {
    return null;
  }

  if ((selectors === null || selectors === void 0 ? void 0 : selectors.length) === 1) {
    return selectors[0];
  }

  return createSelector(selectors.slice(0, -1), selectors.slice(-1)[0]);
};

function objectSet(obj, paths, value) {
  var isImmutable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var _paths = paths;

  if (typeof _paths === 'string') {
    _paths = _paths.split('.');
  }

  var tailObj = _paths.slice(0, -1).reduce(function (acc, pathItem) {
    if (!acc[pathItem]) {
      acc[pathItem] = Object.create(null);
    } else if (isImmutable) {
      acc[pathItem] = _objectSpread2({}, acc[pathItem]);
    }

    return acc[pathItem];
  }, obj);

  tailObj[_paths.slice(-1)[0]] = value;
  return obj;
}
function immutableObjectSet(obj, paths, value) {
  return objectSet(_objectSpread2({}, obj), paths, value, true);
}

function createModelActionsByEffects(model, exportModel, store) {
  var effects = model.effects,
      name = model.name;

  if (!effects) {
    return;
  }

  var isFunctionTemp = isFunction(effects);

  if (process.env.NODE_ENV !== 'production') {
    !(isFunctionTemp || isPlainObject$1(effects)) ? process.env.NODE_ENV !== "production" ? invariant(false, "".concat(name, "Model.effects must be a function or an object")) : invariant(false) : void 0;
  }

  var modelDescEffects;

  if (isFunctionTemp) {
    // pass exportModel as context
    var appContext = {
      models: store._context.exportModels,
      Plugins: store._context.Plugins,
      extra: store._context.extra,
      ssrContext: store._context.ssrContext || undefined
    };

    if (typeof Proxy === 'function') {
      appContext = new Proxy(appContext, {
        get: function get(target, key) {
          var utils = store._context._utils || {};

          if (utils[key]) {
            return utils[key];
          }

          return target[key];
        }
      });
    } else {
      // @TODO utils挂载需要优化
      ['fetch', 'axios'].forEach(function (key) {
        Object.defineProperty(appContext, key, {
          get: function get() {
            var utils = store._context._utils || {};

            if (utils[key]) {
              return utils[key];
            }

            return undefined;
          }
        });
      });
    }

    modelDescEffects = effects(exportModel, appContext);
  } else {
    modelDescEffects = effects;
  } // 对 model 的嵌套 actions 结构处理


  var _parseModelEffects = parseModelEffects(name, modelDescEffects, store),
      _parseModelEffects2 = _slicedToArray(_parseModelEffects, 1),
      actions = _parseModelEffects2[0];

  Object.assign(exportModel.actions, actions);
} // 遍历 effects，并针对根节点的 action function 进行包装
// 修改了 model 定义的 actions 对象
// wrapperLeafFunc: 针对叶子节点函数的包装处理

function parseModelEffects(modelName, modelDescEffects, store) {
  return recursiveParse(modelDescEffects);

  function recursiveParse(modelDescEffects) {
    var paths = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var exportActions = {};
    var exportActionCreators = {};
    var exportTypes = {};
    Object.keys(modelDescEffects).forEach(function (actionKey) {
      var effectHandler = modelDescEffects[actionKey];

      if (isFunction(effectHandler)) {
        // not include modelName, eg: 'TODO'
        var actionPath = [].concat(_toConsumableArray(paths), [actionKey]).join('/');

        var _createWrapperAction = createWrapperAction({
          modelName: modelName,
          actionPath: actionPath,
          effectHandler: effectHandler
        }, store),
            _createWrapperAction2 = _slicedToArray(_createWrapperAction, 2),
            dispatchAction = _createWrapperAction2[1];

        dispatchAction.TYPE = actionPath;
        exportActions[actionKey] = dispatchAction;
      } else if (isPlainObject$1(effectHandler)) {
        var _recursiveParse = recursiveParse(effectHandler, paths.concat(actionKey)),
            _recursiveParse2 = _slicedToArray(_recursiveParse, 3),
            _exportActions = _recursiveParse2[0],
            _exportActionCreators = _recursiveParse2[1],
            _exportTypes = _recursiveParse2[2];

        exportActions[actionKey] = _exportActions;
        exportActionCreators[actionKey] = _exportActionCreators;
        Object.assign(exportTypes, _exportTypes);
      }
    });
    return [exportActions, exportActionCreators, exportTypes];
  }
}

function parsePath(path) {
  var type = path.toUpperCase();

  var _path$split = path.split('/'),
      _path$split2 = _toArray(_path$split),
      modelName = _path$split2[0],
      pathInModel = _path$split2.slice(1);

  var funcName = pathInModel.slice(-1)[0];
  return {
    type: type,
    modelName: modelName,
    pathInModel: pathInModel,
    funcName: funcName
  };
}
/*
 * 对默认的 effects 包裹处理
 * modelName: 'todos'
 * leafKey: 'add'
 * leaf: addFunc
 * type: actionType  'TODOS/xxx/ADD'
 */


function createWrapperAction(_ref, store) {
  var modelName = _ref.modelName,
      actionPath = _ref.actionPath,
      effectHandler = _ref.effectHandler;
  var actionCreator = null;
  /*
   * actionCreator: 返回的 actionCreator 函数
   * dispatchAction: 对 actionCreator 函数进行 dispatch 封装
   * 由于 actionCreator 函数返回结果，统一是 {type, payload} 格式，
   * 所以直接 dispatch，并不是所有中间件都能处理这种类型，所以在真正 dispatch 之前，需要返回各个中间件需要dispatch的结果
   * (利用 plugin 提供的 beforeDispatchAction API 在 dispatch 之前处理)
   */

  var type = "".concat(modelName, "/").concat(actionPath).toUpperCase();

  if (!actionCreator) {
    actionCreator = function actionCreator() {
      return {
        type: type,
        // type: `${modelName}/${actionPath}`.toUpperCase(),
        // type: `${exportModel.name}/${actionPath}`.toUpperCase(),
        payload: effectHandler.apply(void 0, arguments)
      };
    };
  }

  var dispatchAction = function dispatchAction() {
    return store.dispatch(actionCreator.apply(void 0, arguments));
  };

  return [actionCreator, dispatchAction];
}
/*
 * genDefaultActionCreator, genDefaultAction 分别是生成 Model.actions/reducers 的 actionCreator, action 函数
 *
 * actionPath: tood/load/fulfilled
 */


function genDefaultActionCreator(actionPath, model) {
  var _parsePath = parsePath(actionPath),
      type = _parsePath.type,
      pathInModel = _parsePath.pathInModel;

  function actionCreator(payload, meta) {
    var action = {
      type: type
    };

    if (typeof payload !== 'undefined') {
      action.payload = payload;
    } // 注意: 由于绑定组件时直接将 action 绑定在事件处理函数上，容易导致第二个参数为 event
    // event 体积过大，会导致 redux devtoos 工具警告提示 slow。
    // if (args[1] && args[1].nativeEvent) {
    //   args[1] = null;
    // }


    if (typeof meta !== 'undefined' && !meta.nativeEvent) {
      action.meta = meta;
    }

    return action;
  } // 保存 actionPath 路径


  actionCreator.actionPath = actionPath;
  objectSet(model, ['_actionCreators'].concat(_toConsumableArray(pathInModel)), actionCreator);
  objectSet(model, ['_types', actionPath.toUpperCase()], actionCreator);
}
function genDefaultAction(actionPath, actionCreator, exportModel, store) {
  var _parsePath2 = parsePath(actionPath),
      pathInModel = _parsePath2.pathInModel;

  function dispatchAction() {
    return store.dispatch(actionCreator.apply(void 0, arguments));
  }

  dispatchAction.TYPE = actionPath.toUpperCase();
  objectSet(exportModel, ['actions'].concat(_toConsumableArray(pathInModel)), dispatchAction);
}

/*
 * 针对 Model 生成相应的 reducers, reducer, actionCreators
 * reducers 为该 Model 对应的 reducer 操作函数
 * reducers: {
 *  'TODO/ADD': (state, payload, meta) => { return {} }
 * }
 *
 * reducer 为最终 combineReducers 聚合的 reducer 函数
 * reducer: (state, action) => {}
 *
 * actionCreators 为符合 FSA 的 actionCreator 函数
 */

function genModelDescReducers(model) {
  if (!model.actions) {
    model.actions = {};
  }

  var actions = model.actions,
      modelName = model.name,
      curModelReducers = model._reducers; // 当前 model actions 集合
  // 扁平

  var flatModelReducers = parseModelReducers(actions);
  Object.keys(flatModelReducers).reduce(function (result, key) {
    var reducerFunc = flatModelReducers[key];
    var reducerPath = [modelName, key].join('/'); // todo/load/fulfilled
    // 不能对原函数进行修改（否则多次 extend baseModel，baseModel 不一致）
    // [error] (reducerFunc as any).reducerPath = reducerPath;
    // 生成相应的 actionCreator 函数

    genDefaultActionCreator(reducerPath, model);
    return Object.assign(result, _defineProperty({}, reducerPath.toUpperCase(), reducerFunc));
  }, curModelReducers);
  var modelReducer = combineModelReducer(curModelReducers);
  model._reducer = modelReducer;
} // const fakeReferenceClosures: any = { rootReducer: null };
// function fakeRootReducer(state: any, action: any) {
//   const { rootReducer } = fakeReferenceClosures;
//   return rootReducer(state, action);
// }

/* 创建根 reducer 函数 */

function createRootReducer(_ref) {
  var models = _ref.models,
      context = _ref.context;
  var rootReducers = models.reduce(function (_rootReducers, model) {
    var name = model.name; // record origin model

    context._models[name] || (context._models[name] = model);
    _rootReducers[name] = createModelReducer(model, context);
    return _rootReducers;
  }, context._reducers);

  if (!Object.keys(rootReducers).length && !context._pluginHelper.ifNeedComposeRootReducer()) {
    return function (state) {
      return state;
    };
  } // must to be regenerate


  var _rootReducer = function _rootReducer(state) {
    return state;
  };

  if (Object.keys(rootReducers).length) {
    _rootReducer = (context._override.combineReducers || combineReducers)(rootReducers);
  } // avoid multiple call, due to dynamically add models
  // fake closuer, in order to get new _rootReducer


  context.__rootReducer__ = _rootReducer;

  if (!context.__fakeRootReducer__) {
    context.__fakeRootReducer__ = function (state, action) {
      // fake closuer, in order to get new _rootReducer
      var __rootReducer__ = context.__rootReducer__;

      var allState = __rootReducer__(state, action);

      context._allState = allState;
      return allState;
    };
  }

  if (!context.__tagRootReducer__) {
    context._rootReducer = context._pluginHelper.composeRootReducer(context.__fakeRootReducer__);
    context.__tagRootReducer__ = true;
  }

  return context._rootReducer;
}
function createModelActionsByReducers(model, exportModel, store) {
  var _reducers = model._reducers;
  Object.keys(_reducers).forEach(function (upperReducerPath) {
    // upperReducerPath: 'TODO/ADD'
    // actionPath: 'todo/add'
    var actionCreator = model._types[upperReducerPath];
    var actionPath = actionCreator.actionPath;
    genDefaultAction(actionPath, actionCreator, exportModel, store);
  });
}
function createModelReducer(model, context) {
  // const { _reducer, computed, name } = model;
  return withComputed(model, context); // return function(state: any = model.initialState, action: any) {
  //   context._lastState[model.name as string] = state;
  //   return modelReducer(state, action);
  // };
}
/*
computed: {
  // 1.
  test: state => state.xxx
  testFun: state => dynamicParams => xx
  // 2.reselector

}
*/

function withComputed(model, // {
//   _reducer: modelReducer,
//   computed: modelComputed,
//   name: modelName,
// }: Pick<ImplicitModelDesc, '_reducer' | 'computed' | 'name'>,
context) {
  // if (!modelComputed) {
  //   return modelReducer;
  // }
  var modelReducer = model._reducer,
      _model$computed = model.computed,
      modelComputed = _model$computed === void 0 ? {} : _model$computed,
      modelName = model.name;
  var computedDescriptors = Object.keys(modelComputed).reduce(function (_computedDescriptors, name) {
    // generate computed selector function
    var selector = generateComputedSelector(modelComputed[name], context); // generate computed descriptor

    _computedDescriptors[name] = {
      get: function get() {
        // this 指当前 modelState
        var result = selector(this, context._lastState[modelName], context._allState);

        if (isFunction(result)) {
          if (!result.memorizeFunc) {
            result.memorizeFunc = function () {
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              if (!shallowEqual(args, result.memorizeparams)) {
                result.memorizeparams = args;
                result.memorizeResult = result.apply(void 0, args);
                return result.memorizeResult;
              } else {
                return result.memorizeResult;
              }
            };
          }

          return result.memorizeFunc;
        }

        return result;
      },
      // NOTICE: not enumerable, avoid spread state to getter call. (reducer {...state})
      enumerable: false,
      configurable: true
    };
    return _computedDescriptors;
  }, {});
  context._descriptors[modelName] = computedDescriptors;
  return function () {
    var modelState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : model.initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    // 如果使用了 immer 插件，注意 computed 计算的 descriptors 放在 immmer 插件处特殊处理
    if (context._pluginsMap['@reduck/plugin-immer']) {
      return modelReducer(modelState, action);
    } else {
      // record last state
      context._lastState[modelName] = modelState;
      var rt = modelReducer(modelState, action);
      isUndefined(rt) && (rt = modelState);
      return Object.defineProperties(rt, computedDescriptors);
    }
  };
} // 针对 model combine reducer


function combineModelReducer(modelReducers) {
  return function (state) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (typeof modelReducers[action.type] === 'function') {
      var nextState = modelReducers[action.type](state, action.payload, action.meta);
      return nextState;
    }

    return state;
  };
} // 递归解析 reducers 嵌套结构


function parseModelReducers(modelDescReducers) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  if (process.env.NODE_ENV !== 'production') {
    !isPlainObject$1(modelDescReducers) ? process.env.NODE_ENV !== "production" ? invariant(false, "Invalid actions. An object expected.") : invariant(false) : void 0;
  }

  return Object.keys(modelDescReducers).reduce(function (result, key) {
    // 针对 handleEffect API 会生成 __init__ 的函数不做处理
    // if (key === '__init__') {
    //   return result;
    // }
    var item = modelDescReducers[key];

    var _isFunction = isFunction(item);

    var pathedKey = path ? [path, key].join('/') : key;
    return Object.assign(result, _isFunction ? _defineProperty({}, pathedKey, item) : parseModelReducers(item, pathedKey));
  }, {});
}

function generateComputedSelector(computedFunc, context) {
  var selector = null;

  if (isFunction(computedFunc)) {
    var wrapperFn = function wrapperFn(state, lastState, allState) {
      // 标识所处运行状态为 computed 部分，通过此标识，在 computed 部分禁止访问其余 model 的 state
      context._runStatus = 'computed';
      var rt;

      try {
        rt = computedFunc(state, lastState, allState);
      } finally {
        // 保证 runStatus 正常
        context._runStatus = null;
      }

      if (isFunction(rt)) {
        return function () {
          context._runStatus = 'computed';
          var rtt;

          try {
            rtt = rt.apply(void 0, arguments);
          } finally {
            context._runStatus = null;
          }

          return rtt;
        };
      } else {
        return rt;
      }
    };

    selector = wrapperFn; // Dont have to memoize, due to the state's reference are different every time

    selector = memorize(wrapperFn);
  } else if (isArray(computedFunc)) {
    selector = memorizeSelector(computedFunc);
  }

  return selector;
}

/*
 * 将 Model 部分转换逻辑封装在 createModel 中，相比 Rematch 减少了计算（比如在复用场景）
 * Model.actions 结构生成相应的 reducers、reducer、actionCreators
 */

function createModel(_name) {
  var _createModel = function _createModel(modelDesc) {
    var name;

    if (isString(_name)) {
      name = modelDesc.name = modelDesc.namespace = _name;
    }

    name = modelDesc.name = modelDesc.namespace || modelDesc.name;

    if (process.env.NODE_ENV !== 'production') ;

    if (process.env.NODE_ENV !== 'production') {
      !(isPlainObject$1(modelDesc.state) || isPlainObject$1(modelDesc.initialState)) ? process.env.NODE_ENV !== "production" ? invariant(false, "createModel state must be an object type") : invariant(false) : void 0;
    }

    var initialState = _objectSpread2({}, modelDesc.state || modelDesc.initialState);

    var model = _objectSpread2(_objectSpread2({}, modelDesc), {}, {
      name: name,
      state: null,
      initialState: initialState,
      _reducer: null,
      _reducers: Object.create(null),
      _types: Object.create(null),
      _actionCreators: Object.create(null),
      _isCreateModeled: true
    });

    genModelDescReducers(model);
    return model;
  };

  if (isString(_name)) {
    return {
      define: _createModel
    };
  } else {
    return _createModel(_name);
  }
}

function extend(baseModel, targetModel) {
  var modelDesc = {
    name: targetModel.name || targetModel.namespace || baseModel.name,
    state: _objectSpread2(_objectSpread2({}, baseModel.initialState), targetModel.initialState || targetModel.state),
    actions: _objectSpread2(_objectSpread2({}, baseModel.actions), targetModel.actions),
    computed: _objectSpread2(_objectSpread2({}, baseModel.computed), targetModel.computed),
    effects: function effects(context, hub) {
      return _objectSpread2(_objectSpread2({}, isFunction(baseModel.effects) ? baseModel.effects(context, hub) : baseModel.effects), isFunction(targetModel.effects) ? targetModel.effects(context, hub) : targetModel.effects);
    },
    epics: function epics(context, hub) {
      return _objectSpread2(_objectSpread2({}, isFunction(baseModel.epics) ? baseModel.epics(context, hub) : baseModel.epics), isFunction(targetModel.epics) ? targetModel.epics(context, hub) : targetModel.epics);
    }
  };
  return createModel(modelDesc);
}

function objectGet(obj, paths) {
  var _paths = paths;

  if (isString(_paths)) {
    _paths = _paths.split('.');
  }

  if (isUndefined(_paths)) {
    return undefined;
  }

  var len = _paths.length;
  var rt = obj;

  for (var i = 0; i < len; i++) {
    rt = rt[_paths[i]];

    if (rt == null) {
      return rt;
    } else if (i !== len - 1 && !isPlainObject$1(rt)) {
      throw new Error("get the value on the corresponding path of the ".concat(JSON.stringify(obj), " error"));
    }
  }

  return rt;
}

function handleEffect() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var result = config.result,
      pending = config.pending,
      error = config.error,
      _config$combineMode = config.combineMode,
      combineMode = _config$combineMode === void 0 ? 'merge' : _config$combineMode,
      _config$omitResultNam = config.omitResultNamespace,
      omitResultNamespace = _config$omitResultNam === void 0 ? false : _config$omitResultNam;
  var _config$ns = config.ns,
      ns = _config$ns === void 0 ? false : _config$ns;

  if (process.env.NODE_ENV !== 'production') {
    !(ns === false || isString(ns)) ? process.env.NODE_ENV !== "production" ? invariant(false, "ns param must be set to false or string. please see doc") : invariant(false) : void 0;
  }

  var stateNamesMap = {};

  if (omitResultNamespace === true) {
    ns = false;
  }

  if (ns === false) {
    stateNamesMap = {
      result: result === false ? null : !isUndefined(result) ? "".concat(result) : 'result',
      pending: pending === false ? null : !isUndefined(pending) ? "".concat(pending) : 'pending',
      error: error === false ? null : !isUndefined(error) ? "".concat(error) : 'error'
    };
  } else if (isString(ns)) {
    stateNamesMap = {
      result: result === false ? null : !isUndefined(result) ? "".concat(ns, ".").concat(result) : "".concat(ns, ".result"),
      pending: pending === false ? null : !isUndefined(pending) ? "".concat(ns, ".").concat(pending) : "".concat(ns, ".pending"),
      error: error === false ? null : !isUndefined(error) ? "".concat(ns, ".").concat(error) : "".concat(ns, ".error")
    };
  }

  function getReducer(getChange) {
    return function reducerHandle(state, payload) {
      var resultChange = getChange(state, payload);
      return ['result', 'error', 'pending'].reduce(function (_state, stateKey) {
        var _result = resultChange[stateKey];

        if (stateKey === 'result' && omitResultNamespace === true) {
          return _objectSpread2(_objectSpread2({}, _state), _result);
        }

        if (stateNamesMap[stateKey]) {
          return immutableObjectSet(_state, stateNamesMap[stateKey], _result);
        } else {
          return _state;
        }
      }, state);
    };
  }

  function changeResult(currentResult, newResult) {
    if (isUndefined(newResult)) {
      return currentResult;
    }

    switch (combineMode) {
      case 'replace':
        return newResult;

      case 'merge':
        {
          if (isArray(newResult)) {
            return currentResult == null ? _toConsumableArray(newResult) : [].concat(_toConsumableArray(currentResult), _toConsumableArray(newResult));
          } else if (isPlainObject$1(newResult)) {
            return _objectSpread2(_objectSpread2({}, currentResult), newResult);
          } else {
            return newResult; // throw new Error('we only automatically handle array or object type');
          }
        }

      default:
        return newResult;
    }
  }

  function getCurentResult(state) {
    if (!stateNamesMap.result) {
      return null;
    }

    return objectGet(state, stateNamesMap.result);
  }

  var autoReducerMap = {}; // Object.defineProperty(autoReducerMap, '__init__', {
  //   value: {
  //     stateNamesMap,
  //     handler: getReducer((state: any) => {
  //       return {
  //         pending: false,
  //         error: null,
  //         result: getCurentResult(state) || null,
  //       };
  //     }),
  //   },
  //   enumerable: true,
  // });

  stateNamesMap.pending && (autoReducerMap.pending = getReducer(function (state) {
    return {
      pending: true,
      error: null,
      result: getCurentResult(state) || null
    };
  }));
  autoReducerMap.fulfilled = getReducer(function (state, payload) {
    return {
      pending: false,
      error: null,
      result: changeResult(getCurentResult(state), payload)
    };
  });
  (stateNamesMap.pending || stateNamesMap.error) && (autoReducerMap.rejected = getReducer(function (state) {
    var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Error("async action rejected");
    return {
      pending: false,
      error: payload,
      result: getCurentResult(state) || null
    };
  }));
  return autoReducerMap;
}

var updateState = {
  replace: function replace(payloadName) {
    return _updateState(payloadName, 'replace');
  },
  merge: function merge(payloadName) {
    return _updateState(payloadName, 'merge');
  }
};

function _updateState(payloadName, combineMode) {
  if (isString(payloadName)) {
    return function (state, payload) {
      return getNameResult(state, payload, payloadName, combineMode);
    };
  }

  return getOmitNameReducer(payloadName, combineMode);
}

function getOmitNameReducer(payloadName, combineMode) {
  if (process.env.NODE_ENV !== 'production') {
    !(payloadName === true) ? process.env.NODE_ENV !== "production" ? invariant(false, "updateState.replace or updateState.merge API, the \"payloadName\" parameter must be string or true") : invariant(false) : void 0;
  }

  return function (state, payload) {
    if (combineMode === 'replace') {
      return payload;
    } else {
      return _objectSpread2(_objectSpread2({}, state), payload);
    }
  };
}

function getNameResult(state, payload, payloadName, combineMode) {
  var temp;

  switch (combineMode) {
    case 'replace':
      temp = _defineProperty({}, payloadName, payload);
      break;

    case 'merge':
      {
        if (isArray(payload)) {
          temp = _defineProperty({}, payloadName, [].concat(_toConsumableArray(state[payloadName]), _toConsumableArray(payload)));
        } else if (isObject(payload)) {
          temp = _defineProperty({}, payloadName, _objectSpread2(_objectSpread2({}, state[payloadName]), payload));
        } else {
          temp = _defineProperty({}, payloadName, payload);
        }

        break;
      }

    default:
      throw new Error("updateState.".concat(combineMode, " not exist"));
  }

  return _objectSpread2(_objectSpread2({}, state), temp);
}

function actionThunk(extraArgument) {
  return function () {
    return {
      name: 'internal_actionThunk',
      mergeMiddleware: function mergeMiddleware(middlewares) {
        return middlewares.push(function (_ref) {
          var dispatch = _ref.dispatch,
              getState = _ref.getState;
          return function (next) {
            return function (action) {
              if (isFunction(action)) {
                return action(dispatch, getState, extraArgument);
              }

              if (isFunction(action.payload)) {
                return next(_objectSpread2(_objectSpread2({}, action), {}, {
                  payload: action.payload(dispatch, getState, extraArgument)
                }));
              }

              return next(action);
            };
          };
        });
      }
    };
  };
}
actionThunk.__name__ = 'internal_actionThunk';

var ActionType;

(function (ActionType) {
  ActionType["Pending"] = "PENDING";
  ActionType["Fulfilled"] = "FULFILLED";
  ActionType["Rejected"] = "REJECTED";
})(ActionType || (ActionType = {}));
/**
 * For TypeScript support: Remember to check and make sure
 * that `index.d.ts` is also up to date with the implementation.
 */
// export const ActionType = {
//   Pending: 'PENDING',
//   Fulfilled: 'FULFILLED',
//   Rejected: 'REJECTED',
// };

/*
 * Function: createPromise
 * Description: The main createPromise accepts a configuration
 * object and returns the middleware.
 */


function createPromise() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultTypes = [ActionType.Pending, ActionType.Fulfilled, ActionType.Rejected];
  var PROMISE_TYPE_SUFFIXES = config.promiseTypeSuffixes || defaultTypes;
  var PROMISE_TYPE_DELIMITER = config.promiseTypeDelimiter || '_';
  var disableThrowErrorWhenEffectRejected = config.disableThrowErrorWhenEffectRejected || false;
  return function (ref) {
    var dispatch = ref.dispatch;
    return function (next) {
      return function (action) {
        /**
         * Instantiate variables to hold:
         * (1) the promise
         * (2) the data for optimistic updates
         */
        var promise;
        var data;
        /**
         * There are multiple ways to dispatch a promise. The first step is to
         * determine if the promise is defined:
         * (a) explicitly (action.payload.promise is the promise)
         * (b) implicitly (action.payload is the promise)
         * (c) as an async function (returns a promise when called)
         *
         * If the promise is not defined in one of these three ways, we don't do
         * anything and move on to the next middleware in the middleware chain.
         */
        // Step 1a: Is there a payload?

        if (action.payload) {
          var PAYLOAD = action.payload; // Step 1.1: Is the promise implicitly defined?

          if (isPromise(PAYLOAD)) {
            promise = PAYLOAD;
          } // Step 1.2: Is the promise explicitly defined?
          else if (isPromise(PAYLOAD.promise)) {
            promise = PAYLOAD.promise;
            data = PAYLOAD.data;
          } // Step 1.3: Is the promise returned by an async function?
          else if (typeof PAYLOAD === 'function' || typeof PAYLOAD.promise === 'function') {
            promise = PAYLOAD.promise ? PAYLOAD.promise() : PAYLOAD();
            data = PAYLOAD.promise ? PAYLOAD.data : undefined; // Step 1.3.1: Is the return of action.payload a promise?

            if (!isPromise(promise)) {
              // If not, move on to the next middleware.
              return next(_objectSpread2(_objectSpread2({}, action), {}, {
                payload: promise
              }));
            }
          } // Step 1.4: If there's no promise, move on to the next middleware.
          else {
            return next(action);
          } // Step 1b: If there's no payload, move on to the next middleware.

        } else {
          return next(action);
        }
        /**
         * Instantiate and define constants for:
         * (1) the action type
         * (2) the action meta
         */


        var TYPE = action.type;
        var META = action.meta;
        /**
         * Instantiate and define constants for the action type suffixes.
         * These are appended to the end of the action type.
         */

        var _PROMISE_TYPE_SUFFIXE = _slicedToArray(PROMISE_TYPE_SUFFIXES, 3),
            PENDING = _PROMISE_TYPE_SUFFIXE[0],
            FULFILLED = _PROMISE_TYPE_SUFFIXE[1],
            REJECTED = _PROMISE_TYPE_SUFFIXE[2];
        /*
         * Function: getAction
        Description: This function constructs and returns a rejected
        or fulfilled action object. The action object is based off the Flux
        Standard Action (FSA).
         Given an original action with the type FOO:
         The rejected object model will be:
        {
        error: true,
        type: 'FOO_REJECTED',
        payload: ...,
        meta: ... (optional)
        }
         The fulfilled object model will be:
        {
        type: 'FOO_FULFILLED',
        payload: ...,
        meta: ... (optional)
        }
         */


        var getAction = function getAction(newPayload, isRejected) {
          return _objectSpread2(_objectSpread2(_objectSpread2({
            // Concatenate the type string property.
            type: [TYPE, isRejected ? REJECTED : FULFILLED].join(PROMISE_TYPE_DELIMITER)
          }, typeof newPayload === 'undefined' ? {} : {
            payload: newPayload
          }), META !== undefined ? {
            meta: META
          } : {}), isRejected ? {
            error: true
          } : {});
        };
        /*
         * Function: handleReject
        Calls: getAction to construct the rejected action
        Description: This function dispatches the rejected action and returns
        the original Error object. Please note the developer is responsible
        for constructing and throwing an Error object. The middleware does not
        construct any Errors.
         */


        var handleReject = function handleReject(reason) {
          var rejectedAction = getAction(reason, true);
          dispatch(rejectedAction);

          if (typeof window !== 'undefined' && disableThrowErrorWhenEffectRejected) {
            console.error(reason);
          } else {
            throw reason;
          }
        };
        /*
         * Function: handleFulfill
        Calls: getAction to construct the fullfilled action
        Description: This function dispatches the fulfilled action and
        returns the success object. The success object should
        contain the value and the dispatched action.
         */


        var handleFulfill = function handleFulfill(value) {
          var resolvedAction = getAction(value, false);
          dispatch(resolvedAction);
          return {
            value: value,
            action: resolvedAction
          };
        };
        /**
         * First, dispatch the pending action:
         * This object describes the pending state of a promise and will include
         * any data (for optimistic updates) and/or meta from the original action.
         */


        next(_objectSpread2(_objectSpread2({
          // Concatenate the type string.
          type: [TYPE, PENDING].join(PROMISE_TYPE_DELIMITER)
        }, data !== undefined ? {
          payload: data
        } : {}), META !== undefined ? {
          meta: META
        } : {}));
        /**
         * Second, dispatch a rejected or fulfilled action and move on to the
         * next middleware.
         */

        return promise.then(handleFulfill, handleReject);
      };
    };
  };
}

function actionPromise(config) {
  return function () {
    return {
      name: 'internal_actionPromise',
      mergeMiddleware: function mergeMiddleware(middlewares) {
        return middlewares.push(createPromise(config));
      }
    };
  };
}
actionPromise.__name__ = 'internal_actionPromise';

/* eslint-disable */
var repeat = function repeat(str, times) {
  return new Array(times + 1).join(str);
};
var pad = function pad(num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num;
};
var formatTime = function formatTime(time) {
  return "".concat(pad(time.getHours(), 2), ":").concat(pad(time.getMinutes(), 2), ":").concat(pad(time.getSeconds(), 2), ".").concat(pad(time.getMilliseconds(), 3));
}; // Use performance API if it's available in order to get better precision

var timer = typeof performance !== 'undefined' && performance !== null && typeof performance.now === 'function' ? performance : Date;

/* eslint-disable */
var $scope,
    conflict,
    conflictResolution = [];

if ((typeof global === "undefined" ? "undefined" : _typeof(global)) === 'object' && global) {
  $scope = global;
} else if (typeof window !== 'undefined') {
  $scope = window;
} else {
  $scope = {};
}

conflict = $scope.DeepDiff;

if (conflict) {
  conflictResolution.push(function () {
    if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
      $scope.DeepDiff = conflict;
      conflict = undefined;
    }
  });
} // nodejs compatible on server side and in the browser.


function inherits(ctor, superCtor) {
  ctor.super_ = superCtor;
  ctor.prototype = Object.create(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
}

function Diff(kind, path) {
  Object.defineProperty(this, 'kind', {
    value: kind,
    enumerable: true
  });

  if (path && path.length) {
    Object.defineProperty(this, 'path', {
      value: path,
      enumerable: true
    });
  }
}

function DiffEdit(path, origin, value) {
  DiffEdit.super_.call(this, 'E', path);
  Object.defineProperty(this, 'lhs', {
    value: origin,
    enumerable: true
  });
  Object.defineProperty(this, 'rhs', {
    value: value,
    enumerable: true
  });
}

inherits(DiffEdit, Diff);

function DiffNew(path, value) {
  DiffNew.super_.call(this, 'N', path);
  Object.defineProperty(this, 'rhs', {
    value: value,
    enumerable: true
  });
}

inherits(DiffNew, Diff);

function DiffDeleted(path, value) {
  DiffDeleted.super_.call(this, 'D', path);
  Object.defineProperty(this, 'lhs', {
    value: value,
    enumerable: true
  });
}

inherits(DiffDeleted, Diff);

function DiffArray(path, index, item) {
  DiffArray.super_.call(this, 'A', path);
  Object.defineProperty(this, 'index', {
    value: index,
    enumerable: true
  });
  Object.defineProperty(this, 'item', {
    value: item,
    enumerable: true
  });
}

inherits(DiffArray, Diff);

function arrayRemove(arr, from, to) {
  var rest = arr.slice((to || from) + 1 || arr.length);
  arr.length = from < 0 ? arr.length + from : from;
  arr.push.apply(arr, rest);
  return arr;
}

function realTypeOf(subject) {
  var type = _typeof(subject);

  if (type !== 'object') {
    return type;
  }

  if (subject === Math) {
    return 'math';
  } else if (subject === null) {
    return 'null';
  } else if (Array.isArray(subject)) {
    return 'array';
  } else if (Object.prototype.toString.call(subject) === '[object Date]') {
    return 'date';
  } else if (typeof subject.toString === 'function' && /^\/.*\//.test(subject.toString())) {
    return 'regexp';
  }

  return 'object';
}

function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
  path = path || [];
  stack = stack || [];
  var currentPath = path.slice(0);

  if (typeof key !== 'undefined') {
    if (prefilter) {
      if (typeof prefilter === 'function' && prefilter(currentPath, key)) {
        return;
      } else if (_typeof(prefilter) === 'object') {
        if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) {
          return;
        }

        if (prefilter.normalize) {
          var alt = prefilter.normalize(currentPath, key, lhs, rhs);

          if (alt) {
            lhs = alt[0];
            rhs = alt[1];
          }
        }
      }
    }

    currentPath.push(key);
  } // Use string comparison for regexes


  if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
    lhs = lhs.toString();
    rhs = rhs.toString();
  }

  var ltype = _typeof(lhs);

  var rtype = _typeof(rhs);

  var ldefined = ltype !== 'undefined' || stack && stack[stack.length - 1].lhs && stack[stack.length - 1].lhs.hasOwnProperty(key);
  var rdefined = rtype !== 'undefined' || stack && stack[stack.length - 1].rhs && stack[stack.length - 1].rhs.hasOwnProperty(key);

  if (!ldefined && rdefined) {
    changes(new DiffNew(currentPath, rhs));
  } else if (!rdefined && ldefined) {
    changes(new DiffDeleted(currentPath, lhs));
  } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
    changes(new DiffEdit(currentPath, lhs, rhs));
  } else if (realTypeOf(lhs) === 'date' && lhs - rhs !== 0) {
    changes(new DiffEdit(currentPath, lhs, rhs));
  } else if (ltype === 'object' && lhs !== null && rhs !== null) {
    if (!stack.filter(function (x) {
      return x.lhs === lhs;
    }).length) {
      stack.push({
        lhs: lhs,
        rhs: rhs
      });

      if (Array.isArray(lhs)) {
        var i,
            len = lhs.length;

        for (i = 0; i < lhs.length; i++) {
          if (i >= rhs.length) {
            changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
          } else {
            deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
          }
        }

        while (i < rhs.length) {
          changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
        }
      } else {
        var akeys = Object.keys(lhs);
        var pkeys = Object.keys(rhs);
        akeys.forEach(function (k, i) {
          var other = pkeys.indexOf(k);

          if (other >= 0) {
            deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
            pkeys = arrayRemove(pkeys, other);
          } else {
            deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
          }
        });
        pkeys.forEach(function (k) {
          deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
        });
      }

      stack.length = stack.length - 1;
    } else if (lhs !== rhs) {
      // lhs is contains a cycle at this element and it differs from rhs
      changes(new DiffEdit(currentPath, lhs, rhs));
    }
  } else if (lhs !== rhs) {
    if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
      changes(new DiffEdit(currentPath, lhs, rhs));
    }
  }
}

function accumulateDiff(lhs, rhs, prefilter, accum) {
  accum = accum || [];
  deepDiff(lhs, rhs, function (diff) {
    if (diff) {
      accum.push(diff);
    }
  }, prefilter);
  return accum.length ? accum : undefined;
}

function applyArrayChange(arr, index, change) {
  if (change.path && change.path.length) {
    var it = arr[index],
        i,
        u = change.path.length - 1;

    for (i = 0; i < u; i++) {
      it = it[change.path[i]];
    }

    switch (change.kind) {
      case 'A':
        applyArrayChange(it[change.path[i]], change.index, change.item);
        break;

      case 'D':
        delete it[change.path[i]];
        break;

      case 'E':
      case 'N':
        it[change.path[i]] = change.rhs;
        break;
    }
  } else {
    switch (change.kind) {
      case 'A':
        applyArrayChange(arr[index], change.index, change.item);
        break;

      case 'D':
        arr = arrayRemove(arr, index);
        break;

      case 'E':
      case 'N':
        arr[index] = change.rhs;
        break;
    }
  }

  return arr;
}

function applyChange(target, source, change) {
  if (target && source && change && change.kind) {
    var it = target,
        i = -1,
        last = change.path ? change.path.length - 1 : 0;

    while (++i < last) {
      if (typeof it[change.path[i]] === 'undefined') {
        it[change.path[i]] = typeof change.path[i] === 'number' ? [] : {};
      }

      it = it[change.path[i]];
    }

    switch (change.kind) {
      case 'A':
        applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
        break;

      case 'D':
        delete it[change.path[i]];
        break;

      case 'E':
      case 'N':
        it[change.path[i]] = change.rhs;
        break;
    }
  }
}

function revertArrayChange(arr, index, change) {
  if (change.path && change.path.length) {
    // the structure of the object at the index has changed...
    var it = arr[index],
        i,
        u = change.path.length - 1;

    for (i = 0; i < u; i++) {
      it = it[change.path[i]];
    }

    switch (change.kind) {
      case 'A':
        revertArrayChange(it[change.path[i]], change.index, change.item);
        break;

      case 'D':
        it[change.path[i]] = change.lhs;
        break;

      case 'E':
        it[change.path[i]] = change.lhs;
        break;

      case 'N':
        delete it[change.path[i]];
        break;
    }
  } else {
    // the array item is different...
    switch (change.kind) {
      case 'A':
        revertArrayChange(arr[index], change.index, change.item);
        break;

      case 'D':
        arr[index] = change.lhs;
        break;

      case 'E':
        arr[index] = change.lhs;
        break;

      case 'N':
        arr = arrayRemove(arr, index);
        break;
    }
  }

  return arr;
}

function revertChange(target, source, change) {
  if (target && source && change && change.kind) {
    var it = target,
        i,
        u;
    u = change.path.length - 1;

    for (i = 0; i < u; i++) {
      if (typeof it[change.path[i]] === 'undefined') {
        it[change.path[i]] = {};
      }

      it = it[change.path[i]];
    }

    switch (change.kind) {
      case 'A':
        // Array was modified...
        // it will be an array...
        revertArrayChange(it[change.path[i]], change.index, change.item);
        break;

      case 'D':
        // Item was deleted...
        it[change.path[i]] = change.lhs;
        break;

      case 'E':
        // Item was edited...
        it[change.path[i]] = change.lhs;
        break;

      case 'N':
        // Item is new...
        delete it[change.path[i]];
        break;
    }
  }
}

function applyDiff(target, source, filter) {
  if (target && source) {
    var onChange = function onChange(change) {
      if (!filter || filter(target, source, change)) {
        applyChange(target, source, change);
      }
    };

    deepDiff(target, source, onChange);
  }
}

Object.defineProperties(accumulateDiff, {
  diff: {
    value: accumulateDiff,
    enumerable: true
  },
  observableDiff: {
    value: deepDiff,
    enumerable: true
  },
  applyDiff: {
    value: applyDiff,
    enumerable: true
  },
  applyChange: {
    value: applyChange,
    enumerable: true
  },
  revertChange: {
    value: revertChange,
    enumerable: true
  },
  isConflict: {
    value: function value() {
      return 'undefined' !== typeof conflict;
    },
    enumerable: true
  },
  noConflict: {
    value: function value() {
      if (conflictResolution) {
        conflictResolution.forEach(function (it) {
          it();
        });
        conflictResolution = null;
      }

      return accumulateDiff;
    },
    enumerable: true
  }
});

var dictionary = {
  E: {
    color: '#2196F3',
    text: 'CHANGED:'
  },
  N: {
    color: '#4CAF50',
    text: 'ADDED:'
  },
  D: {
    color: '#F44336',
    text: 'DELETED:'
  },
  A: {
    color: '#2196F3',
    text: 'ARRAY:'
  }
};
function style(kind) {
  return "color: ".concat(dictionary[kind].color, "; font-weight: bold");
}
function render(diff) {
  var kind = diff.kind,
      path = diff.path,
      lhs = diff.lhs,
      rhs = diff.rhs,
      index = diff.index,
      item = diff.item;

  switch (kind) {
    case 'E':
      return [path.join('.'), lhs, '→', rhs];

    case 'N':
      return [path.join('.'), rhs];

    case 'D':
      return [path.join('.')];

    case 'A':
      return ["".concat(path.join('.'), "[").concat(index, "]"), item];

    default:
      return [];
  }
}
function diffLogger(prevState, newState, logger, isCollapsed) {
  var diff = accumulateDiff(prevState, newState);

  try {
    if (isCollapsed) {
      logger.groupCollapsed('diff');
    } else {
      logger.group('diff');
    }
  } catch (e) {
    logger.log('diff');
  }

  if (diff) {
    diff.forEach(function (elem) {
      var kind = elem.kind;
      var output = render(elem);
      logger.log.apply(logger, ["%c ".concat(dictionary[kind].text), style(kind)].concat(_toConsumableArray(output)));
    });
  } else {
    logger.log('—— no diff ——');
  }

  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— diff end —— ');
  }
}

/**
 * Get log level string based on supplied params
 *
 * @param {string | function | object} level - console[level]
 * @param {object} action - selected action
 * @param {array} payload - selected payload
 * @param {string} type - log entry type
 *
 * @returns {string} level
 */

function getLogLevel(level, action, payload, type) {
  switch (_typeof(level)) {
    case 'object':
      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];

    case 'function':
      return level(action);

    default:
      return level;
  }
}

function defaultTitleFormatter(options) {
  var timestamp = options.timestamp,
      duration = options.duration;
  return function (action, time, took) {
    var parts = ['action'];
    parts.push("%c".concat(String(action.type)));
    if (timestamp) parts.push("%c@ ".concat(time));
    if (duration) parts.push("%c(in ".concat(took.toFixed(2), " ms)"));
    return parts.join(' ');
  };
}

function printBuffer(buffer, options) {
  var logger = options.logger,
      actionTransformer = options.actionTransformer,
      _options$titleFormatt = options.titleFormatter,
      titleFormatter = _options$titleFormatt === void 0 ? defaultTitleFormatter(options) : _options$titleFormatt,
      collapsed = options.collapsed,
      colors = options.colors,
      level = options.level,
      diff = options.diff; // OPERATION: DELETE
  // const isUsingDefaultFormatter = typeof options.titleFormatter === 'undefined';

  buffer.forEach(function (logEntry, key) {
    var started = logEntry.started,
        startedTime = logEntry.startedTime,
        action = logEntry.action,
        prevState = logEntry.prevState,
        error = logEntry.error;
    var took = logEntry.took,
        nextState = logEntry.nextState;
    var nextEntry = buffer[key + 1];

    if (nextEntry) {
      nextState = nextEntry.prevState;
      took = nextEntry.started - started;
    } // Message


    var formattedAction = actionTransformer(action);
    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
      return nextState;
    }, action, logEntry) : collapsed;
    var formattedTime = formatTime(startedTime);
    var titleCSS = colors.title ? "color: ".concat(colors.title(formattedAction), ";") : '';
    var headerCSS = ['color: gray; font-weight: lighter;'];
    headerCSS.push(titleCSS);
    if (options.timestamp) headerCSS.push('color: gray; font-weight: lighter;');
    if (options.duration) headerCSS.push('color: gray; font-weight: lighter;');
    var title = titleFormatter(formattedAction, formattedTime, took); // Render

    try {
      if (isCollapsed) {
        if (colors.title) {
          logger.groupCollapsed.apply(logger, ["%c ".concat(title)].concat(headerCSS));
        } else logger.groupCollapsed(title);
      } else if (colors.title) {
        logger.group.apply(logger, ["%c ".concat(title)].concat(headerCSS));
      } else {
        logger.group(title);
      }
    } catch (e) {
      logger.log(title);
    }

    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');

    if (prevStateLevel) {
      if (colors.prevState) {
        var styles = "color: ".concat(colors.prevState(prevState), "; font-weight: bold");
        logger[prevStateLevel]('%c prev state', styles, prevState);
      } else logger[prevStateLevel]('prev state', prevState);
    }

    if (actionLevel) {
      if (colors.action) {
        var _styles = "color: ".concat(colors.action(formattedAction), "; font-weight: bold");

        logger[actionLevel]('%c action    ', _styles, formattedAction);
      } else logger[actionLevel]('action    ', formattedAction);
    }

    if (error && errorLevel) {
      if (colors.error) {
        var _styles2 = "color: ".concat(colors.error(error, prevState), "; font-weight: bold;");

        logger[errorLevel]('%c error     ', _styles2, error);
      } else logger[errorLevel]('error     ', error);
    }

    if (nextStateLevel) {
      if (colors.nextState) {
        var _styles3 = "color: ".concat(colors.nextState(nextState), "; font-weight: bold");

        logger[nextStateLevel]('%c next state', _styles3, nextState);
      } else logger[nextStateLevel]('next state', nextState);
    }

    if (diff) {
      diffLogger(prevState, nextState, logger, isCollapsed);
    }

    try {
      logger.groupEnd();
    } catch (e) {
      logger.log('—— log end ——');
    }
  });
}

/* eslint-disable */
var defaults = {
  level: 'log',
  logger: console,
  logErrors: true,
  collapsed: undefined,
  predicate: undefined,
  duration: false,
  timestamp: true,
  stateTransformer: function stateTransformer(state) {
    return state;
  },
  actionTransformer: function actionTransformer(action) {
    return action;
  },
  errorTransformer: function errorTransformer(error) {
    return error;
  },
  colors: {
    title: function title() {
      return 'inherit';
    },
    prevState: function prevState() {
      return '#9E9E9E';
    },
    action: function action() {
      return '#03A9F4';
    },
    nextState: function nextState() {
      return '#4CAF50';
    },
    error: function error() {
      return '#F20404';
    }
  },
  diff: false,
  diffPredicate: undefined,
  // Deprecated options
  transformer: undefined
};

/* eslint-disable */
/* eslint max-len: ["error", 110, { "ignoreComments": true }] */

/**
 * Creates logger with following options
 *
 * @namespace
 * @param {object} options - options for logger
 * @param {string | function | object} options.level - console[level]
 * @param {boolean} options.duration - print duration of each action?
 * @param {boolean} options.timestamp - print timestamp with each action?
 * @param {object} options.colors - custom colors
 * @param {object} options.logger - implementation of the `console` API
 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
 * @param {boolean} options.collapsed - is group collapsed?
 * @param {boolean} options.predicate - condition which resolves logger behavior
 * @param {function} options.stateTransformer - transform state before print
 * @param {function} options.actionTransformer - transform action before print
 * @param {function} options.errorTransformer - transform error before print
 *
 * @returns {function} logger middleware
 */

function createLogger() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var loggerOptions = Object.assign({}, defaults, options);
  var logger = loggerOptions.logger,
      stateTransformer = loggerOptions.stateTransformer,
      errorTransformer = loggerOptions.errorTransformer,
      predicate = loggerOptions.predicate,
      logErrors = loggerOptions.logErrors,
      diffPredicate = loggerOptions.diffPredicate; // Return if 'console' object is not defined

  if (typeof logger === 'undefined') {
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  } // Detect if 'createLogger' was passed directly to 'applyMiddleware'.


  if (options.getState && options.dispatch) {
    console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n");
    return function () {
      return function (next) {
        return function (action) {
          return next(action);
        };
      };
    };
  }

  var logBuffer = [];
  return function (_ref) {
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        // Exit early if predicate function returns 'false'
        if (typeof predicate === 'function' && !predicate(getState, action)) {
          return next(action);
        }

        var logEntry = {};
        logBuffer.push(logEntry);
        logEntry.started = timer.now();
        logEntry.startedTime = new Date();
        logEntry.prevState = stateTransformer(getState());
        logEntry.action = action;
        var returnedValue;

        if (logErrors) {
          try {
            returnedValue = next(action);
          } catch (e) {
            logEntry.error = errorTransformer(e);
          }
        } else {
          returnedValue = next(action);
        }

        logEntry.took = timer.now() - logEntry.started;
        logEntry.nextState = stateTransformer(getState());
        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;
        printBuffer(logBuffer, Object.assign({}, loggerOptions, {
          diff: diff
        }));
        logBuffer.length = 0;
        if (logEntry.error) throw logEntry.error;
        return returnedValue;
      };
    };
  };
}

function handleLoggerConfig(actionTypePrefix, loggerConfig) {
  // 针对 localModel，对 redux-logger 特殊处理，标识 @@local
  Object.assign(loggerConfig, {
    actionTransformer: function actionTransformer(action) {
      action.type = actionTypePrefix + action.type;
      return action;
    }
  });
  return loggerConfig;
}

function checkMergeReducers(srcReducers, targetReducers) {
  for (var reducerKey in srcReducers) {
    if (process.env.NODE_ENV !== 'production') {
      !(targetReducers[reducerKey] == undefined) ? process.env.NODE_ENV !== "production" ? invariant(false, "NOTICE: reducer [".concat(reducerKey, "] have existed")) : invariant(false) : void 0;
    }

    targetReducers[reducerKey] = srcReducers[reducerKey];
  }

  return targetReducers;
}

function pluginsHelper(_ref, context) {
  var plugins = _ref.plugins;
  var bindPlugins = plugins.map(function (plugin) {
    var pluginResult = plugin(context);

    if (process.env.NODE_ENV !== 'production') {
      !!isUndefined(pluginResult.name) ? process.env.NODE_ENV !== "production" ? invariant(false, "".concat(plugin.toString(), " \n plugin must set name")) : invariant(false) : void 0;
    } // invariant(
    //   !hub.pluginsMap[pluginResult.name],
    //   `${pluginResult.name} plugin already exists, or its name conflicts with the other plugin`,
    // );
    // 记录已加载的插件


    context._pluginsMap[pluginResult.name] = pluginResult;
    return pluginResult;
  }); // init

  mergeMiddlewares();
  mergeReducers();
  override(); // merge plugin 所有的 reducers 到 context._reducers

  function mergeReducers() {
    return bindPlugins.reduce(function (reducersMap, plugin) {
      var pluginReducers = plugin.mergeReducers;

      if (!pluginReducers) {
        return reducersMap;
      }

      return checkMergeReducers(pluginReducers, reducersMap);
    }, context._reducers);
  } // merge middleware


  function mergeMiddlewares() {
    bindPlugins.forEach(function (plugin) {
      if (!plugin.mergeMiddleware) {
        return;
      } // invariant(
      //   isFunction(plugin.mergeMiddleware),
      //   'plugin.mergeMiddleware must be function',
      // );
      // plugin中的middlware会被合并到hub.middlewares，而且是最高优先级


      plugin.mergeMiddleware(context._middlewares);
    });
  }

  function override() {
    var overrideResult = {
      combineReducers: null
    };
    Object.keys(overrideResult).forEach(function (overrideKey) {
      bindPlugins.forEach(function (plugin) {
        if (plugin.override && plugin.override[overrideKey]) {
          if (overrideResult[overrideKey]) {
            console.warn("Warning: the plugin.override.".concat(overrideKey, " have been set by the plugin ").concat(JSON.stringify(plugin, null, 4)));
          }

          overrideResult[overrideKey] = plugin.override[overrideKey];
        }
      });
    });
    context._override = overrideResult;
  }

  return {
    ifNeedComposeRootReducer: function ifNeedComposeRootReducer() {
      return bindPlugins.some(function (plugin) {
        return plugin.rootReducer;
      });
    },
    forEachPlugin: function forEachPlugin(method, fn) {
      var _iterator = _createForOfIteratorHelper(bindPlugins),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var plugin = _step.value;

          if (plugin[method]) {
            fn(plugin[method]);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    // example: @reduck/plugin-persist. in order to wrap rootReducer
    composeRootReducer: function composeRootReducer(rootReducer) {
      return bindPlugins.reduce(function (_rootReducer, plugin) {
        return plugin.rootReducer ? plugin.rootReducer(_rootReducer) : _rootReducer;
      }, rootReducer);
    },
    // composeOnCreateApp: (WrappedComponent: React.ComponentType<any>): React.ComponentType<any> => {
    //   return bindPlugins.reduce((WrapComp: React.ComponentType<any>, plugin) => {
    //     return plugin.onCreateApp
    //       ? plugin.onCreateApp(WrapComp)
    //       : WrapComp;
    //   }, WrappedComponent);
    // },
    // composeOnCreateAppBefore: (): Promise<any> | null => {
    //   const onCreateAppBeforeArray: any[] = [];
    //   bindPlugins.forEach(plugin => {
    //     const { onCreateAppBefore } = plugin;
    //     if (onCreateAppBefore) {
    //       const rt = onCreateAppBefore();
    //       if (isPromise(rt)) {
    //         onCreateAppBeforeArray.push(rt);
    //       } else {
    //         onCreateAppBeforeArray.push(Promise.resolve(rt));
    //       }
    //     }
    //   });
    //   if (onCreateAppBeforeArray.length) {
    //     return Promise.all(onCreateAppBeforeArray);
    //   }
    //   return null;
    // },
    // composeBeforeDispatchAction: () => {
    //   return (...args: any[]) => {
    //     return (hub.store.dispatch as any)(...args);
    //   };
    // },
    composeProvider: function composeProvider(element, config) {
      return bindPlugins.reduce(function (ele, plugin) {
        return plugin.Provider ? plugin.Provider(ele, config) : ele;
      }, element);
    }
  };
}

function patchStore(store) {
  if (store.hasOwnProperty('hasModel')) {
    return;
  }

  store.hasModel = function (model) {
    var context = store._context;
    var modelName = typeof model === 'string' ? model : model.name;
    return Boolean(context.exportModels[modelName]);
  };

  store.unmountModel = function (models) {
    var arrModels = Array.isArray(models) ? models : [models];
    var context = store._context;
    var hasUnmount = false;
    arrModels.forEach(function (model) {
      var name = typeof model === 'string' ? model : model.name;

      if (!context.exportModels[name]) {
        return;
      }

      hasUnmount = true;
      delete context.exportModels[name];
      delete store.dispatch[name];
      delete context._models[name];
      delete context._lastState[name];

      context._reducers[name] = function () {
        return '__reduck_clear_state__';
      };
    });

    if (hasUnmount) {
      store.replaceReducer(createRootReducer({
        models: [],
        context: context
      }));
    }
  };
}

function createContext(_ref) {
  var models = _ref.models,
      store = _ref.store;
  patchStore(store);
  models.forEach(function (model) {
    createContextModel({
      model: model,
      store: store
    });
  });
}
function createContextModel(_ref2) {
  var model = _ref2.model,
      store = _ref2.store;
  var name = model.name,
      initialState = model.initialState;
  var exportModel = {
    name: name,
    state: null,
    initialState: initialState,
    actions: Object.create(null)
  };
  Object.defineProperty(exportModel, 'state', {
    get: function get() {
      var rootState = store.getState();
      return rootState[name];
    },
    configurable: true
  }); // NOTICE:first resolve model.effects, in order to call model.actions.load.fulfilled

  createModelActionsByEffects(model, exportModel, store);
  createModelActionsByReducers(model, exportModel, store);
  var _context = store._context; // record actions to store.dispatch

  store.dispatch[name] = exportModel.actions; // record exportModels

  _context.exportModels[name] = exportModel; // record origin model

  _context._models[name] || (_context._models[name] = model); // record last state

  _context._lastState[name] = initialState;

  _context._pluginHelper.forEachPlugin('onModelMount', function (onModelMount) {
    onModelMount(_context, model);
  });

  return exportModel;
}

var Batch = /*#__PURE__*/_createClass(function Batch() {
  var _this = this;

  _classCallCheck(this, Batch);

  this.start = function () {
    if (!_this.isInBatch) {
      _this.isInBatch = true;

      _this.notify();
    }
  };

  this.end = function () {
    if (_this.isInBatch) {
      _this.isInBatch = false;

      _this.notify();
    }
  };

  this.subscribe = function (listener) {
    _this.listener = listener;
  };

  this.tagHasUpdates = function () {
    _this.hasUpdates = true;
  };

  this.notify = function () {
    if (typeof _this.listener === 'function' && _this.hasUpdates) {
      _this.listener(_this.isInBatch);

      _this.hasUpdates = false;
    }
  };

  this.runInBatch = function (callback) {
    var res = {};

    if (_this.isInBatch) {
      // eslint-disable-next-line callback-return
      res = callback();
    } else {
      _this.start();

      try {
        // eslint-disable-next-line callback-return
        res = callback();
      } finally {
        _this.end();
      }
    }

    return res;
  };

  this.isInBatch = false;
});

function createStore$1(config, _context) {
  var _context$_middlewares;

  var context = _context;

  if (!context) {
    context = {
      extra: config.extra || {},
      exportModels: {},
      Plugins: {},
      store: {},
      _lastState: {},
      _pluginHelper: null,
      _models: {},
      _override: {},
      _runStatus: null,
      _descriptors: {},
      _reducers: {},
      _middlewares: [],
      _pluginsMap: {},
      _rootReducer: null,
      _utils: {},
      _allState: {}
    };
  }

  var _config$disableLogger = config.disableLogger,
      disableLogger = _config$disableLogger === void 0 ? false : _config$disableLogger,
      _config$disableDevToo = config.disableDevTools,
      disableDevTools = _config$disableDevToo === void 0 ? false : _config$disableDevToo,
      _config$loggerConfig = config.loggerConfig,
      loggerConfig = _config$loggerConfig === void 0 ? {} : _config$loggerConfig,
      _config$devToolsOptio = config.devToolsOptions,
      devToolsOptions = _config$devToolsOptio === void 0 ? {} : _config$devToolsOptio,
      _config$middlewares = config.middlewares,
      middlewares = _config$middlewares === void 0 ? [] : _config$middlewares,
      _config$initialState = config.initialState,
      initialState = _config$initialState === void 0 ? {} : _config$initialState,
      _config$models = config.models,
      models = _config$models === void 0 ? [] : _config$models,
      _config$plugins = config.plugins,
      plugins = _config$plugins === void 0 ? [] : _config$plugins,
      _config$reducers = config.reducers,
      reducers = _config$reducers === void 0 ? {} : _config$reducers,
      _config$thunkWithExtr = config.thunkWithExtraArgument,
      thunkWithExtraArgument = _config$thunkWithExtr === void 0 ? null : _config$thunkWithExtr,
      _config$promiseConfig = config.promiseConfig,
      promiseConfig = _config$promiseConfig === void 0 ? {
    promiseTypeDelimiter: '/'
  } : _config$promiseConfig;
  promiseConfig.promiseTypeDelimiter = promiseConfig.promiseTypeDelimiter || '/';
  var _config$actionTypePre = config.actionTypePrefix,
      actionTypePrefix = _config$actionTypePre === void 0 ? '' : _config$actionTypePre; // merge config to context

  Object.assign(context._reducers, reducers);

  (_context$_middlewares = context._middlewares).push.apply(_context$_middlewares, _toConsumableArray(middlewares));

  context._pluginHelper = pluginsHelper({
    plugins: [actionThunk(thunkWithExtraArgument), actionPromise(promiseConfig)].concat(_toConsumableArray(plugins))
  }, context);
  var middlewaresToApply = [];
  var composeEnhancers = compose; // 开发调试是否禁止

  if (process.env.NODE_ENV !== 'production') {
    var isDevToolsDisabled = disableDevTools || (typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object';
    middlewaresToApply.push(isDevToolsDisabled || disableLogger ? null : createLogger(handleLoggerConfig(actionTypePrefix, loggerConfig)));
    composeEnhancers = !isDevToolsDisabled && (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(devToolsOptions) : compose;
  }

  middlewaresToApply.push.apply(middlewaresToApply, _toConsumableArray(context._middlewares));
  var store = createStore(createRootReducer({
    models: models,
    context: context
  }), initialState, composeEnhancers(applyMiddleware.apply(void 0, _toConsumableArray(middlewaresToApply.filter(Boolean)))));
  context.store = store;
  store._context = context;
  store.models = context.exportModels;
  store._context._batch = new Batch();

  store._context._batch.subscribe(function (isInBatch) {
    if (isInBatch) {
      return;
    }

    store.notifyListeners();
  }); // 给 store 增加控制 batch 的函数


  store.suspendNotify = store._context._batch.start;
  store.resumeNotify = store._context._batch.end;

  context._pluginHelper.forEachPlugin('onStoreAfter', function (onStoreAfter) {
    return onStoreAfter(store);
  });

  createContext({
    models: models,
    store: store
  });
  return store;
}

// window special tag

if (!isNode) {
  window.__REDUCK__ = true;
}

function createApp() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$plugins = config.plugins,
      plugins = _config$plugins === void 0 ? [] : _config$plugins,
      _config$extra = config.extra,
      extra = _config$extra === void 0 ? {} : _config$extra;
  return createHocRef(function (WrappedComponent) {
    var WrappedApp = /*#__PURE__*/function (_React$PureComponent) {
      _inherits(WrappedApp, _React$PureComponent);

      var _super = _createSuper(WrappedApp);

      function WrappedApp(props) {
        var _props$_ssrData, _props$_ssrData$conte, _props$_ssrData2, _props$_ssrData2$data;

        var _this;

        _classCallCheck(this, WrappedApp);

        _this = _super.call(this, props);
        _this.store = null;
        var context = {
          extra: extra,
          exportModels: {},
          Plugins: {},
          ssrContext: props._ssrData && props._ssrData.context || {},
          _lastState: {},
          _pluginHelper: null,
          _models: {},
          _override: {},
          _runStatus: null,
          _descriptors: {},
          _reducers: {},
          _middlewares: [],
          _pluginsMap: {},
          _rootReducer: null
        }; // ssr, by _ssrData to get store

        if (props !== null && props !== void 0 && (_props$_ssrData = props._ssrData) !== null && _props$_ssrData !== void 0 && (_props$_ssrData$conte = _props$_ssrData.context) !== null && _props$_ssrData$conte !== void 0 && _props$_ssrData$conte.store && (!props.moduleName || !props.moduleSourceUrl)) {
          _this.store = props._ssrData.context.store;
          return _possibleConstructorReturn(_this);
        } // ssr->csr, by _ssrData to get store initialState


        if (props !== null && props !== void 0 && (_props$_ssrData2 = props._ssrData) !== null && _props$_ssrData2 !== void 0 && (_props$_ssrData2$data = _props$_ssrData2.data) !== null && _props$_ssrData2$data !== void 0 && _props$_ssrData2$data.storeState) {
          config.initialState = props._ssrData.data.storeState;
        }

        if (props.store) {
          if (Object.keys(props.store).length === 0) {
            // ssr first render, easy to get the same store reference
            _this.store = Object.assign(props.store, createStore$1(config, context));
          } else {
            _this.store = props.store;
          }
        } else {
          _this.store = createStore$1(config, context);
        }

        return _this;
      }

      _createClass(WrappedApp, [{
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          delete this.store._context;
          this.store = null;
        }
      }, {
        key: "render",
        value: function render() {
          var _context = this.store._context;
          var children = this.props.children;
          var WrappedElement = React.createElement(WrappedComponent, _objectSpread2({
            store: this.store
          }, this.props), children);

          var root = _context._pluginHelper.composeProvider(WrappedElement, _objectSpread2(_objectSpread2({}, config), this.props));

          root = React.createElement(Provider, {
            store: this.store,
            config: config
          }, config.Provider ? React.createElement(config.Provider, {
            store: this.store
          }, root) : root);
          return root;
        }
      }]);

      return WrappedApp;
    }(React.PureComponent);

    return pluginSpecialHookHelper({
      plugins: plugins
    }).composeOnCreateApp(hoistNonReactStatic(WrappedApp, WrappedComponent), config);
  });
}

// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect : useEffect;

var EMPTY_ARRAY = [];

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function storeStateUpdatesReducer(state, action) {
  var _state = _slicedToArray(state, 2),
      updateCount = _state[1];

  return [action.payload, updateCount + 1];
}
/* models and selector --- end */
// arg: 用于解析  parseUseModels 参数
// dep: useMemo 依赖
// extra: connect 用于传递 ownProps


function useModel(arg) {
  var dep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var _info = arguments.length > 3 ? arguments[3] : undefined;

  var _ref = _info || {},
      isStatic = _ref.isStatic,
      customContext = _ref.context;

  var context = useContext(customContext || ReactReduxContext);

  if (process.env.NODE_ENV !== 'production') {
    !(context === null || context === void 0 ? void 0 : context.store) ? process.env.NODE_ENV !== "production" ? invariant(false, "could not find Reduck context value; please ensure the App RootComponent is wrapped in createApp()(App). \n\n    ") : invariant(false) : void 0;
  }

  var store = context.store,
      contextSubscription = context.subscription;

  var _useMemo = useMemo(parseUseModels(arg), [arg]),
      _useMemo2 = _slicedToArray(_useMemo, 3),
      models = _useMemo2[0],
      selectorState = _useMemo2[1],
      selectorActions = _useMemo2[2];

  if (process.env.NODE_ENV !== 'production') {
    !(models || []).every(function (model) {
      return Boolean(model.name || model.namespace);
    }) ? process.env.NODE_ENV !== "production" ? invariant(false, "useModel([modelA, ...]), every model should have 'name' property as its namespace\n\n    ") : invariant(false) : void 0;
  }

  var needReloadSelectorRef = useRef(0);
  var needToAddedModels = [];
  models === null || models === void 0 ? void 0 : models.forEach(function (model) {
    var modelName = model.name;
    var contextModel = store._context.exportModels[modelName];

    if (!contextModel) {
      createContextModel({
        model: model,
        store: store
      });
      needToAddedModels.push(model);
    }
  });

  if (needToAddedModels !== null && needToAddedModels !== void 0 && needToAddedModels.length) {
    needReloadSelectorRef.current += 1;
    store.replaceReducer(createRootReducer({
      models: needToAddedModels,
      context: store._context
    }));
  }

  var subscription = useMemo(function () {
    return new Subscription(store, contextSubscription);
  }, [store, contextSubscription]);

  var _useReducer = useReducer(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _slicedToArray(_useReducer2[0], 1),
      previousStateUpdateResult = _useReducer2$[0],
      forceComponentUpdateDispatch = _useReducer2[1]; // Propagate any mapState/mapDispatch errors upwards


  if (previousStateUpdateResult !== null && previousStateUpdateResult !== void 0 && previousStateUpdateResult.error) {
    throw previousStateUpdateResult.error;
  } // used to shallowEqual


  var lastSelectedStateRef = useRef(null); // used to avoid unnecessary selector call, when tigger store update

  var stateFromStoreUpdate = useRef(null);
  var ownProps = extra === null || extra === void 0 ? void 0 : extra.ownProps;
  var lastOwnProps = useRef(ownProps);
  var selectedState = useMemo(function () {
    // if stateFromStoreUpdate.current not null, maybe due to subscription.onStateChange tigger self re-render, so that the value of stateFromStoreUpdate.current already is latested that recalculated by selectorState
    if (stateFromStoreUpdate.current && ownProps === lastOwnProps.current) {
      return stateFromStoreUpdate.current;
    }

    return selectorState === null || selectorState === void 0 ? void 0 : selectorState(store.getState(), extra === null || extra === void 0 ? void 0 : extra.ownProps); // if previousStateUpdateResult changed(forceUpdate), selectorState call again
  }, [store, previousStateUpdateResult, needReloadSelectorRef.current].concat(_toConsumableArray(dep)));
  var proxySelectedState = useCallback(function () {
    if (isStatic) {
      var hasProxyed = Boolean(lastSelectedStateRef.current);

      if (!lastSelectedStateRef.current) {
        lastSelectedStateRef.current = _objectSpread2({}, selectedState);
      }

      Object.defineProperties(selectedState, Object.keys(lastSelectedStateRef.current || {}).reduce(function (res, key) {
        var shouldProxy = !hasProxyed || !selectedState.hasOwnProperty(key);

        if (shouldProxy) {
          res[key] = {
            get: function get() {
              var _lastSelectedStateRef;

              return (_lastSelectedStateRef = lastSelectedStateRef.current) === null || _lastSelectedStateRef === void 0 ? void 0 : _lastSelectedStateRef[key];
            }
          };
        }

        return res;
      }, {}));
    }
  }, [selectedState]);
  useMemo(function () {
    proxySelectedState();
  }, [selectedState]); // remain unchanged, even called multiple times

  var selectedActions = useMemo(function () {
    return selectorActions(store.dispatch, extra === null || extra === void 0 ? void 0 : extra.ownProps);
  }, [store, needReloadSelectorRef.current]);
  useIsomorphicLayoutEffect(function () {
    if (stateFromStoreUpdate.current) {
      stateFromStoreUpdate.current = null;
    } // used to compare. if equal, avoid unnecessary rendering and keep constant reference


    if (!isStatic) {
      lastSelectedStateRef.current = selectedState;
    }

    lastOwnProps.current = ownProps;
  });
  useIsomorphicLayoutEffect(function () {
    var didUnsubscribe = false;
    var lastThrownError = null;

    var checkForUpdates = function checkForUpdates() {
      if (didUnsubscribe) {
        return;
      }

      var latestStoreState = store.getState();
      var newSelectedState;
      var error;

      try {
        // Actually run the selector with the most recent store state and wrapper props
        // to determine what the child props should be
        newSelectedState = selectorState === null || selectorState === void 0 ? void 0 : selectorState(latestStoreState, extra === null || extra === void 0 ? void 0 : extra.ownProps);
        stateFromStoreUpdate.current = newSelectedState;
      } catch (e) {
        error = e;
        lastThrownError = e;
      }

      if (!error) {
        lastThrownError = null;
      } // used to compare. if equal, avoid unnecessary rendering and keep constant reference


      if (!shallowEqual(newSelectedState, lastSelectedStateRef.current)) {
        lastSelectedStateRef.current = newSelectedState;

        if (isStatic && Object.keys(lastSelectedStateRef.current || {}).length !== Object.keys(selectedState).length) {
          proxySelectedState();
        }

        !isStatic && forceComponentUpdateDispatch({
          type: 'STORE_UPDATED',
          payload: {
            error: error
          }
        });
      }
    };

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // ?? why call again
    // Pull data from the store after first render in case the store has
    // changed since we began.

    checkForUpdates();
    return function () {
      didUnsubscribe = true;
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;

      if (lastThrownError) {
        throw lastThrownError;
      }
    };
  }, [store, subscription]);
  return [selectedState, selectedActions];
}

var _excluded = ["ReactforwardedRef"];

function connect(arg) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var forwardRef = opt.forwardRef;
  var isHasMapActions = false;

  if (isArray(arg)) {
    var length = arg.length;
    var lastMap = arg[length - 1];
    var sencondLastMap = arg[length - 2];
    var isFunctionLastMap = isFunction(lastMap);
    var isFunctionSencondLastMap = isFunction(sencondLastMap);
    var isUndefinedSencondLastMap = sencondLastMap == null;
    isHasMapActions = (isFunctionSencondLastMap || isUndefinedSencondLastMap) && isFunctionLastMap;
  }

  return createHocRef(function (WrappedComponent) {
    function ConnectFunction(props) {
      var _useMemo = useMemo(function () {
        var ReactforwardedRef = props.ReactforwardedRef,
            wrapperProps = _objectWithoutProperties(props, _excluded);

        return [ReactforwardedRef, wrapperProps];
      }, [props]),
          _useMemo2 = _slicedToArray(_useMemo, 2),
          ReactforwardedRef = _useMemo2[0],
          wrapperProps = _useMemo2[1]; // memorize wrapperProps


      var lastWrapperProps = useRef(null);
      useMemo(function () {
        if (!shallowEqual(lastWrapperProps.current, wrapperProps)) {
          lastWrapperProps.current = wrapperProps;
        }
      }, [wrapperProps]);

      var _useModel = useModel(arg, [lastWrapperProps.current], {
        ownProps: lastWrapperProps.current
      }),
          _useModel2 = _slicedToArray(_useModel, 2),
          state = _useModel2[0],
          actions = _useModel2[1];

      var actualChildProps = useMemo(function () {
        return _objectSpread2(_objectSpread2({}, lastWrapperProps.current), state);
      }, [state, lastWrapperProps.current]);
      var renderedWrappedChild = useMemo(function () {
        return createElement(WrappedComponent, _objectSpread2(_objectSpread2(_objectSpread2({}, actualChildProps), isHasMapActions ? _objectSpread2({}, actions) : {
          actions: actions
        }), {}, {
          ref: ReactforwardedRef
        }));
      }, [ReactforwardedRef, WrappedComponent, actualChildProps]);
      return renderedWrappedChild;
    }

    return memo(ConnectFunction);
  }, {
    enableRef: forwardRef
  });
}

var EMPTY_ARRAY$1 = [];

var initStateUpdates$1 = function initStateUpdates() {
  return [null, 0];
};

function storeStateUpdatesReducer$1(state, action) {
  var _state = _slicedToArray(state, 2),
      updateCount = _state[1];

  return [action.payload, updateCount + 1];
}
/* models and selector --- end */


function useLocalModel(arg, _dep, // optional
_configs, // optional
_info) {
  // omit dep, pass configs
  var _useMemo = useMemo(function () {
    if (isPlainObject$1(_dep) && isUndefined(_configs)) {
      return [[], _dep];
    }

    return [_dep || [], _configs || {}];
  }, [_dep, _configs]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      dep = _useMemo2[0],
      configs = _useMemo2[1];

  if (process.env.NODE_ENV !== 'production') {
    !(isArray(dep) && isPlainObject$1(configs)) ? process.env.NODE_ENV !== "production" ? invariant(false, "useLocalModel API, the second param [dependency] must be Array or Optional; the third param [configs] must be Object or Optional \n") : invariant(false) : void 0;
  }

  var _useMemo3 = useMemo(parseUseModels(arg, true), [arg]),
      _useMemo4 = _slicedToArray(_useMemo3, 3),
      models = _useMemo4[0],
      selectorState = _useMemo4[1],
      selectorActions = _useMemo4[2];

  if (process.env.NODE_ENV !== 'production') {
    !(models || []).every(function (model) {
      return Boolean(model.name || model.namespace);
    }) ? process.env.NODE_ENV !== "production" ? invariant(false, "when useLocalModel([modelA, modelB, ...], every model should have 'name' property as its namespace)\n") : invariant(false) : void 0;
  }

  var _ref = _info || {},
      isStatic = _ref.isStatic,
      customContext = _ref.context;

  var _ref2 = useContext(customContext || ReactReduxContext) || {},
      globalStore = _ref2.store,
      globalConfig = _ref2.config;

  var _useMemo5 = useMemo(function () {
    var defaultConfigs = {
      actionTypePrefix: '@@local~~'
    };
    var context = {
      _localModelTypePrefix: '@@local~~',
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
      extra: configs.extra || {},
      exportModels: {},
      Plugins: {},
      store: {},
      _pluginHelper: null,
      _models: {},
      _override: {},
      _runStatus: null,
      _descriptors: {},
      _reducers: {},
      _middlewares: [],
      _pluginsMap: {},
      _rootReducer: null,
      _lastState: {},
      _utils: globalStore ? globalStore._context._utils : {},
      _allState: {}
    };

    var _store = createStore$1(_objectSpread2(_objectSpread2({
      models: models
    }, defaultConfigs), mergeConfigFromGlobal(globalConfig, configs)), context);

    _store._context = context;
    createContext({
      models: models,
      store: _store
    });

    var _subscription = new Subscription(_store);

    return {
      store: _store,
      subscription: _subscription
    };
  }, models),
      store = _useMemo5.store,
      subscription = _useMemo5.subscription;

  var _useReducer = useReducer(storeStateUpdatesReducer$1, EMPTY_ARRAY$1, initStateUpdates$1),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _slicedToArray(_useReducer2[0], 1),
      previousStateUpdateResult = _useReducer2$[0],
      forceComponentUpdateDispatch = _useReducer2[1]; // Propagate any mapState/mapDispatch errors upwards


  if (previousStateUpdateResult !== null && previousStateUpdateResult !== void 0 && previousStateUpdateResult.error) {
    throw previousStateUpdateResult.error;
  }

  var selectedState = useMemo(function () {
    return selectorState === null || selectorState === void 0 ? void 0 : selectorState(store.getState(), configs === null || configs === void 0 ? void 0 : configs.ownProps);
  }, [store, previousStateUpdateResult].concat(_toConsumableArray(dep))); // remain unchanged, even called multiple times

  var selectedActions = useMemo(function () {
    return selectorActions(store.dispatch, configs === null || configs === void 0 ? void 0 : configs.ownProps);
  }, [store]);
  var lastSelectedStateRef = useRef(null);
  var proxySelectedState = useCallback(function () {
    if (isStatic) {
      var hasProxyed = lastSelectedStateRef.current;

      if (!lastSelectedStateRef.current) {
        lastSelectedStateRef.current = _objectSpread2({}, selectedState);
      }

      Object.defineProperties(selectedState, Object.keys(lastSelectedStateRef.current || {}).reduce(function (res, key) {
        var shouldProxy = !hasProxyed || !selectedState.hasOwnProperty(key);

        if (shouldProxy) {
          res[key] = {
            get: function get() {
              var _lastSelectedStateRef;

              return (_lastSelectedStateRef = lastSelectedStateRef.current) === null || _lastSelectedStateRef === void 0 ? void 0 : _lastSelectedStateRef[key];
            }
          };
        }

        return res;
      }, {}));
    }
  }, [selectedState]);
  useMemo(function () {
    proxySelectedState();
  }, [selectedState]);
  useIsomorphicLayoutEffect(function () {
    var didUnsubscribe = false;
    var lastThrownError = null;

    var checkForUpdates = function checkForUpdates() {
      if (didUnsubscribe) {
        return;
      }

      var latestStoreState = store.getState();
      var newSelectedState;
      var error;

      try {
        // Actually run the selector with the most recent store state and wrapper props
        // to determine what the child props should be
        newSelectedState = selectorState === null || selectorState === void 0 ? void 0 : selectorState(latestStoreState, configs === null || configs === void 0 ? void 0 : configs.ownProps);
      } catch (e) {
        error = e;
        lastThrownError = e;
      }

      if (!error) {
        lastThrownError = null;
      }

      if (!shallowEqual(newSelectedState, lastSelectedStateRef.current)) {
        lastSelectedStateRef.current = newSelectedState;

        if (isStatic && Object.keys(lastSelectedStateRef.current || {}).length !== Object.keys(selectedState).length) {
          proxySelectedState();
        }

        if (!isStatic) {
          forceComponentUpdateDispatch({
            type: 'STORE_UPDATED',
            payload: {
              error: error
            }
          });
        }
      }
    };

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    return function () {
      didUnsubscribe = true;
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;

      if (lastThrownError) {
        throw lastThrownError;
      }
    };
  }, [store, subscription]);
  return [selectedState, selectedActions];
}

function mergeConfigFromGlobal(globalConfig, config) {
  if (globalConfig === null || _typeof(globalConfig) !== 'object') {
    return config;
  }

  return ['extra', 'disableDevTools', 'devToolsOptions', 'disableLogger', 'loggerConfig', 'middlewares', 'thunkWithExtraArgument', 'promiseConfig', 'plugins'].reduce(function (inheritConfig, key) {
    if (!globalConfig.hasOwnProperty(key)) {
      return inheritConfig;
    }

    if (key === 'plugins') {
      var filteredPlugins = (globalConfig[key] || []).filter(function (plugin) {
        return plugin.__name__ === '@reduck/plugin-immer';
      });
      inheritConfig[key] = filteredPlugins;
    } else {
      inheritConfig[key] = globalConfig[key];
    }

    return inheritConfig;
  }, config);
}
/* eslint-enable max-lines */

var _excluded$1 = ["forwardRef"],
    _excluded2 = ["ReactforwardedRef"];
function connectLocal(arg) {
  var configs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (process.env.NODE_ENV !== 'production') {
    !!isUndefined(arg) ? process.env.NODE_ENV !== "production" ? invariant(false, "connectLocal API, the first param must to set \n") : invariant(false) : void 0;
  }

  var forwardRef = configs.forwardRef,
      leftConfigs = _objectWithoutProperties(configs, _excluded$1);

  var isHasMapActions = false;

  if (isArray(arg)) {
    var length = arg.length;
    var lastMap = arg[length - 1];
    var sencondLastMap = arg[length - 2];
    var isFunctionLastMap = isFunction(lastMap);
    var isFunctionSencondLastMap = isFunction(sencondLastMap);
    var isUndefinedSencondLastMap = isUndefined(sencondLastMap);
    isHasMapActions = (isFunctionSencondLastMap || isUndefinedSencondLastMap) && isFunctionLastMap;
  }

  return createHocRef(function (WrappedComponent) {
    function ConnectLocalFunction(props) {
      var _useMemo = useMemo(function () {
        var ReactforwardedRef = props.ReactforwardedRef,
            wrapperProps = _objectWithoutProperties(props, _excluded2);

        return [ReactforwardedRef, wrapperProps];
      }, [props]),
          _useMemo2 = _slicedToArray(_useMemo, 2),
          ReactforwardedRef = _useMemo2[0],
          wrapperProps = _useMemo2[1];

      var _useLocalModel = useLocalModel(arg, [wrapperProps], _objectSpread2(_objectSpread2({}, leftConfigs), {}, {
        // configs.ownProps 用于接收 connect 传递的 ownProps
        ownProps: wrapperProps
      })),
          _useLocalModel2 = _slicedToArray(_useLocalModel, 2),
          state = _useLocalModel2[0],
          actions = _useLocalModel2[1];

      var renderedWrappedChild = useMemo(function () {
        return createElement(WrappedComponent, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, wrapperProps), state), isHasMapActions ? _objectSpread2({}, actions) : {
          actions: actions
        }), {}, {
          ref: ReactforwardedRef
        }));
      }, [ReactforwardedRef, WrappedComponent, state, wrapperProps]);
      return renderedWrappedChild;
    }

    return memo(ConnectLocalFunction);
  }, {
    enableRef: forwardRef
  });
}

/* eslint-disable eslint-comments/disable-enable-pair */
/* models and selector --- end */

function useStaticLocalModel(arg, _dep, // optional
_configs) {
  return useLocalModel(arg, _dep, _configs, {
    isStatic: true
  });
}

/* eslint-disable eslint-comments/disable-enable-pair */
/* models and selector --- end */
// arg: 用于解析  parseuseStaticModels 参数
// dep: useMemo 依赖
// extra: connect 用于传递 ownProps

function useStaticModel(arg) {
  var dep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return useModel(arg, dep, [], {
    isStatic: true
  });
}

function useReduckContext() {
  var storeContext = useContext(ReactReduxContext);

  if (process.env.NODE_ENV !== 'production') {
    !storeContext ? process.env.NODE_ENV !== "production" ? invariant(false, "could not find Reduck context value; please ensure the App RootComponent is wrapped in createApp()(App). \n\n    ") : invariant(false) : void 0;
  }

  var store = storeContext.store;
  var rt = useMemo(function () {
    var _context = store._context;
    return {
      extra: _context.extra,
      Plugins: _context.Plugins,
      store: store
    };
  }, [store]);
  return rt;
}

var _excluded$2 = ["ReactforwardedRef"];
function withReduckContext() {
  var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var forwardRef = opt.forwardRef;
  return createHocRef(function (WrappedComponent) {
    function ReduckContextComp(props) {
      var _useMemo = useMemo(function () {
        var ReactforwardedRef = props.ReactforwardedRef,
            wrapperProps = _objectWithoutProperties(props, _excluded$2);

        return [ReactforwardedRef, wrapperProps];
      }, [props]),
          _useMemo2 = _slicedToArray(_useMemo, 2),
          ReactforwardedRef = _useMemo2[0],
          wrapperProps = _useMemo2[1];

      var reduckContext = useReduckContext();
      var renderedWrappedChild = useMemo(function () {
        return createElement(WrappedComponent, _objectSpread2(_objectSpread2(_objectSpread2({}, wrapperProps), reduckContext), {}, {
          ref: ReactforwardedRef
        }));
      }, [ReactforwardedRef, WrappedComponent, reduckContext]);
      return renderedWrappedChild;
    }

    return memo(ReduckContextComp);
  }, {
    enableRef: forwardRef
  });
}

export { Provider, ReactReduxContext, combineReducers, connect, connectLocal, createApp, createModel, createStore as createReduxStore, createStore$1 as createStore, extend, handleEffect, updateState, useLocalModel, useModel, useReduckContext, useStaticLocalModel, useStaticModel, withReduckContext };
//# sourceMappingURL=reduck.esm.js.map
